import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LockerRoomIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 1.5C1 1.22386 1.22386 1 1.5 1H4.5C4.77614 1 5 1.22386 5 1.5V3L1 3V1.5Z"
		></path>
		<path fill="currentColor" d="M1 5V4H5V5L1 5Z"></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5 6H1V14.5C1 14.7761 1.22386 15 1.5 15H4.5C4.77614 15 5 14.7761 5 14.5V6ZM2 8C1.72386 8 1.5 8.22386 1.5 8.5V9.5C1.5 9.77614 1.72386 10 2 10C2.27614 10 2.5 9.77614 2.5 9.5V8.5C2.5 8.22386 2.27614 8 2 8Z"
		></path>
		<path
			fill="currentColor"
			d="M6 1.5C6 1.22386 6.22386 1 6.5 1H9.5C9.77614 1 10 1.22386 10 1.5V3L6 3V1.5Z"
		></path>
		<path fill="currentColor" d="M6 5V4H10V5L6 5Z"></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 6H6V14.5C6 14.7761 6.22386 15 6.5 15H9.5C9.77614 15 10 14.7761 10 14.5V6ZM7 8C6.72386 8 6.5 8.22386 6.5 8.5V9.5C6.5 9.77614 6.72386 10 7 10C7.27614 10 7.5 9.77614 7.5 9.5V8.5C7.5 8.22386 7.27614 8 7 8Z"
		></path>
		<path
			fill="currentColor"
			d="M11.5 1C11.2239 1 11 1.22386 11 1.5V3L15 3V1.5C15 1.22386 14.7761 1 14.5 1H11.5Z"
		></path>
		<path fill="currentColor" d="M11 4V5L15 5V4H11Z"></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11 6H15V14.5C15 14.7761 14.7761 15 14.5 15H11.5C11.2239 15 11 14.7761 11 14.5V6ZM11.5 8.5C11.5 8.22386 11.7239 8 12 8C12.2761 8 12.5 8.22386 12.5 8.5V9.5C12.5 9.77614 12.2761 10 12 10C11.7239 10 11.5 9.77614 11.5 9.5V8.5Z"
		></path>
	</svg>
))
